export enum FooterTypes {
  auth,
  onboarding,
  notFound,
  general,
}
